<template>
  <AddMentor />
</template>
<script>
import appConfig from '@/app.config'
import AddMentor from '../../../components/dadban/mentors/AddMentor.vue'
export default {
  page: {
    title: 'اضافه کردن منتور',
    meta: [
      {
        name: 'description',
        content: appConfig.description,
      },
    ],
  },
  name: 'dadban-add-mentors',
  components: {
    AddMentor,
  },
}
</script>
